module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/446.2efec3da.png";